// Local Gallery Data - Independent from Admin Panel
// Photos from Plumber Meet Event

const galleryData = [
    {
        id: "plumber-meet-1",
        folder: "Plumber Meet",
        images: ["6.jpg", "7.jpg", "8.jpg", "9.jpg", "10.jpg", "11.jpg"],
    },
];

export default galleryData;
